'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _vuStyleSheet = require('@ali/vu-style-sheet');

var _vuStyleSheet2 = _interopRequireDefault(_vuStyleSheet);

var _vuFunctionParser = require('@ali/vu-function-parser');

var _vuFunctionParser2 = _interopRequireDefault(_vuFunctionParser);

var _view = require('./view.childcontainer');

require('./view.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Root = (_temp = _class = function (_Component) {
  _inherits(Root, _Component);

  function Root() {
    _classCallCheck(this, Root);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Root.prototype.componentWillMount = function componentWillMount() {
    var willMount = (0, _vuFunctionParser2.default)(this.props.willMount);
    if (typeof willMount === 'function') {
      willMount(this.props.context);
    }
  };

  Root.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var didMount = (0, _vuFunctionParser2.default)(this.props.didMount);
    if (typeof didMount === 'function') {
      this._onPageReady = this.props.context.onPageReady(function () {
        didMount(_this2.props.context);
      });
    }
  };

  Root.prototype.componentWillUnmount = function componentWillUnmount() {
    // 卸载
    if (this._onPageReady) {
      this._onPageReady();
    }
    var willUnMount = (0, _vuFunctionParser2.default)(this.props.willUnMount);
    if (typeof willUnMount === 'function') {
      willUnMount(this.props.context);
    }
  };

  Root.prototype.render = function render() {
    if (!this.props.className) {
      _vuStyleSheet2.default.invoke('body', this.props.pageStyle);
    }
    var className = (0, _classnames2.default)('vc-root', _vuStyleSheet2.default.invoke('.' + this.props.componentId, this.props.containerStyle, this.props.className), {
      'vc-flexible': this.props.flexible
    });

    return _react2.default.createElement(
      'div',
      { className: className },
      this.props.children
    );
  };

  return Root;
}(_react.Component), _class.displayName = 'Root', _class.propTypes = {
  className: _propTypes2.default.string,
  componentId: _propTypes2.default.string,
  children: _propTypes2.default.node,
  flexible: _propTypes2.default.bool,
  containerStyle: _propTypes2.default.object,
  context: _propTypes2.default.object,
  pageStyle: _propTypes2.default.object,
  willMount: _propTypes2.default.string,
  didMount: _propTypes2.default.string,
  willUnMount: _propTypes2.default.string
}, _class.defaultProps = {
  willMount: 'function() {}',
  didMount: 'function() {}',
  willUnMount: 'function() {}'
}, _temp);
exports.default = [Root, (0, _view.createChildView)({ name: 'RootHeader' }), _view.RootContent, (0, _view.createChildView)({ name: 'RootFooter' })];
module.exports = exports['default'];